import Yup from '../../../../helpers/custom-yup'

export const addressFieldsSchema = Yup.object().shape({
	city: Yup.string().required('Informe a cidade'),
	state: Yup.string().required('Informe o estado')
})
